import { createSelector } from '@reduxjs/toolkit';
import { selectCompanies } from 'app/containers/Company/slice/selectors';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.user || initialState;

export const selectUser = createSelector([selectSlice], state => state);

export const selectUserListState = createSelector(
  [selectUser],
  state => state.userList,
);

export const selectUserListArr = createSelector(
  [selectUserListState],
  userList => userList.list,
);

export const selectUserDetailsState = createSelector(
  [selectUser],
  state => state.userDetails,
);

export const selectAddUserFormState = createSelector(
  [selectUser],
  state => state.addUserForm,
);

export const selectAddUserCompanyFormState = createSelector(
  [selectUser],
  state => state.addUserCompanyForm,
);

export const selectUserAvailableCompanies = createSelector(
  [selectUserDetailsState, selectCompanies],
  (userDetails, companies) =>
    companies.filter(
      company =>
        !userDetails.list.find(userCompany => userCompany.id === company.id),
    ),
);
